import { Vector3 } from 'three'

export default {
	namespaced: true,

	state: {
		isLoaded: false,
		isIntroducted: false,
		introCameraPos: new Vector3(-150, 50, 100),
		introCameraLook: new Vector3(0, -20, 0),
		webGLContainer: null,
		lvlScroll: {
			min: 31,
			max: 150
		},
		redirects: [
			{
				origin: 'city',
				target: 'map',
				icon: 'btn-map.png'
			},
			{
				origin: 'map',
				target: 'city',
				icon: 'btn-city.png'
			},
			{
				origin: 'district',
				target: 'city',
				icon: 'btn-city.png'
			},
			{
				origin: 'keypoint',
				target: 'city',
				icon: 'btn-city.png'
			},
			{
				origin: 'article',
				target: 'city',
				icon: 'btn-city.png'
			},
			{
				origin: 'auditorium',
				target: 'city',
				icon: 'btn-city.png'
			}
		],
		socials: [
			{
				name: 'Facebook',
				icon: 'btn-facebook.png',
				url: 'https://www.facebook.com/brightforme'
			},
			{
				name: 'Twitter',
				icon: 'btn-twitter.png',
				url: `https://twitter.com/brig_ht`
			},
			{
				name: 'Linkedin',
				icon: 'btn-linkedin.png',
				url: 'https://www.linkedin.com/company/brightparis/'
			}
		]
	},

	getters: {
		isLoaded(state) {
			return state.isLoaded
		},
		isIntroducted(state) {
			return state.isIntroducted
		},
		introCameraPos(state) {
			return state.introCameraPos
		},
		introCameraLook(state) {
			return state.introCameraLook
		},
		webGLContainer(state) {
			return state.webGLContainer
		},
		lvlScroll (state) {
			return state.lvlScroll
		},
		redirects (state) {
			return state.redirects
		},
		socials (state) {
			return state.socials
		}
	},

	mutations: {
		loaded(state, payload) {
			state.isLoaded = payload
		},
		introducted(state, payload) {
			state.isIntroducted = payload
		},
		webGLContainer(state, payload) {
			state.webGLContainer = payload
		}
	}
}